import './index.scss';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ApprovedTransactionsTable from '../../components/ApprovedTransactionTable';
import ApprovedTransactionView from '../../components/ApprovedTransactionView';

const ApprovedTransactions = ({ match }) => {
  return (
    <div className="w-100 h-100">
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <ApprovedTransactionsTable {...props} />;
          }}
        />
        <Route
          path={`${match.url}/:txId`}
          exact
          render={(props) => {
            return <ApprovedTransactionView {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default ApprovedTransactions;
